import { NativeExtensions } from '@wix/thunderbolt-components-native'
import { compCssMappersWithModesAndVariants } from './compCssMappersWithModesAndVariantsCompNode'
import { RunAndReportFn } from '@wix/thunderbolt-state-manager'

export const compSelectorToCssMappers = (nativeExtensions: NativeExtensions, runAndReport: RunAndReportFn) => {
	return compCssMappersWithModesAndVariants(nativeExtensions, 'compSelectorToCssMappers', runAndReport)
}
